import {v4 as uuidv4} from 'uuid';
import {AuthorVo} from '../../common/shared/api/nicolas/vo/AuthorVo.interface';
import {Author} from '../generated/types';

export function createAuthor({
  name,
  role,
  role_display_name,
}: AuthorVo): Author {
  return {
    id: uuidv4(),
    name,
    role,
    roleDisplayName: role_display_name,
  };
}
